import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { analyticsApi } from "@/api";
import type { AnalyticsQuery, Granularity, TimelineMetric } from "@/api";
import { QUERY_KEYS } from "@/constants";

/**
 * Panel jamlanmasi — BITTA so'rov.
 *
 * Ilgari bu ekran sakkizta ro'yxat endpointidan `meta.total` yig'ardi va
 * daromadni oxirgi 500 ta to'lovni brauzerda qo'shib hisoblardi. Endi
 * hisob serverda va u to'liq.
 */
export const useAnalyticsOverview = (query: AnalyticsQuery = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_ANALYTICS_OVERVIEW, query],
    queryFn: () => analyticsApi.overview(query),
    placeholderData: keepPreviousData,
    select: res => res.data,
  });

/**
 * Tushum grafigi.
 *
 * Alohida so'rov, chunki oyna va bo'lak o'zgarganda YAKKA o'zi qayta
 * so'raladi — jamlanmani qayta yuklash esa butun ekranni titratardi.
 */
export const useRevenueSeries = (query: AnalyticsQuery & { granularity?: Granularity } = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_ANALYTICS_REVENUE, query],
    queryFn: () => analyticsApi.revenue(query),
    placeholderData: keepPreviousData,
    select: res => res.data,
  });

/** O'sish grafigi: yozilishlar, foydalanuvchilar yoki kurslar. */
export const useTimelineSeries = (
  query: AnalyticsQuery & { metric?: TimelineMetric; granularity?: Granularity } = {},
) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_ANALYTICS_TIMELINE, query],
    queryFn: () => analyticsApi.timeline(query),
    placeholderData: keepPreviousData,
    select: res => res.data,
  });
